var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Tipos Facturar","company":_vm.comdes,"addMethod":"itemsTipoFacturar","closeBaseWindow":"addTipoFacturar","titleAddMethod":"Agregar Tipos Facturar","itemStoreName":"itemsTipoFacturar","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Tipos Facturar',
    edicion: 'Editar Tipos Facturar',
    url: `/transjuma/TipoFacturar/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }